module.exports = __webpack_public_path__ + "static/media/Shipping Crisis Explainer_1632873000610.4efffec8.vtt";